import { render, staticRenderFns } from "./indexTracking.vue?vue&type=template&id=76143c4c&"
import script from "./indexTracking.vue?vue&type=script&lang=ts&"
export * from "./indexTracking.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports